import {Component, Input} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {UserAttribute} from "../../../../../model/user-attribute";

@Component({
  selector: 'attribute-string',
  templateUrl: './attribute-string.component.html',
  styleUrls: ['./attribute-string.component.scss']
})
export class AttributeStringComponent {
  @Input() attribute: UserAttribute;
  @Input() form: FormGroup;
  @Input() disabled: boolean
  @Input() readonly: boolean
  value: string;
}
